const singleMetricSnapshot = {
    id: 'cGFuZWw6NWQ4YzQzNzAxNjIzYWU2MmEwNGMxY2E2',
    partnerId: 349,
    clientId: 7101,
    name: 'Multi Metric',
    description: '',
    publishTier: null,
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    widget: {
        id: '1',
        name: null,
        type: null,
        userAssetId: null,
        userAssetContentUrl: null,
        classes: 'template_multi_metric',
        theme: {
            colorPrimary: '',
            colorSecondary: '#ff6060',
            colorBackground: '',
            colorNegative: '',
            colorPostive: '',
            fontFamilyPrimary: '',
            fontFamilySecondary: '',
            fontSizePrimary: '',
            backgroundImage: {
                url: '',
            },
            ext: {
                padding: 40,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            typography: {
                color: '',
                size: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    textTransform: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    textTransform: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                solid: '',
                ranked: {
                    colors: [],
                    contrast: null,
                },
                overrides: [],
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        label: {
            titleText: 'Header',
            enabled: false,
            size: 20,
        },
        css: null,
        js: null,
        postRequests: null,
        analyticsRequests: null,
        profileRequests: null,
        trendRequests: null,
        children: [
            {
                id: '1',
                name: 'Multi Metric',
                type: 'multiMetric',
                userAssetId: null,
                userAssetContentUrl: null,
                classes: null,
                theme: {
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    backgroundImage: {
                        url: '',
                    },
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    typography: {
                        color: '',
                        size: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            textTransform: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            textTransform: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        solid: '',
                        ranked: {
                            colors: [],
                            contrast: null,
                        },
                        overrides: [],
                    },
                },
                position: {
                    left: '0',
                    right: null,
                    top: '0',
                    bottom: null,
                    width: '100%',
                    height: '100%',
                    portrait: null,
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                label: {
                    titleText: 'Multi Metric',
                    enabled: true,
                    size: 20,
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                },
                css: null,
                js: null,
                postRequests: null,
                analyticsResults: [
                    {
                        dataSets: [
                            {
                                metrics: [
                                    {
                                        name: 'Outbound Count',
                                        type: 'NUMBER',
                                        aggregateFunction: 'SUM',
                                    },
                                    {
                                        name: 'Inbound Count',
                                        type: 'NUMBER',
                                        aggregateFunction: 'SUM',
                                    },
                                    {
                                        name: 'LIKE_COUNT',
                                        type: 'NUMBER',
                                        aggregateFunction: 'SUM',
                                    },
                                ],
                                dimensions: [],
                                rows: [[761, 451, 0]],
                            },
                            {
                                metrics: [
                                    {
                                        name: 'Outbound Count',
                                        type: 'NUMBER',
                                        aggregateFunction: 'SUM',
                                    },
                                    {
                                        name: 'Inbound Count',
                                        type: 'NUMBER',
                                        aggregateFunction: 'SUM',
                                    },
                                    {
                                        name: 'LIKE_COUNT',
                                        type: 'NUMBER',
                                        aggregateFunction: 'SUM',
                                    },
                                ],
                                dimensions: [],
                                rows: [[899, 521, 0]],
                            },
                        ],
                    },
                ],
                analyticsRequests: [
                    {
                        report: 'SPRINKSIGHTS',
                        reportingEngine: 'LISTENING',
                        limit: 1,
                        sorts: [],
                        includeTotal: null,
                        timeField: null,
                        timePeriods: [
                            {
                                duration: 86400000,
                                startTime: 1596870000000,
                                endTime: 1597474799999,
                                timeZone: 'America/Los_Angeles',
                                key: 'last_7_days',
                                previousPeriod: false,
                                wholePeriods: false,
                                xValue: null,
                            },
                            {
                                duration: 86400000,
                                startTime: null,
                                endTime: null,
                                timeZone: 'America/Los_Angeles',
                                key: null,
                                previousPeriod: true,
                                wholePeriods: false,
                                xValue: null,
                            },
                        ],
                        groupBys: [],
                        filters: [
                            {
                                dimensionName: 'TOPIC_GROUP_IDS',
                                filterType: 'IN',
                                values: ['5a04774ce4b07f3ea5fd383e'],
                                details: null,
                            },
                        ],
                        projections: [
                            {
                                heading: 'Mentions',
                                measurementName: 'MENTIONS_COUNT',
                                aggregateFunction: 'SUM',
                                details: null,
                            },
                            {
                                heading: 'Distinct Users',
                                measurementName: 'DISTINCT_USER_COUNT',
                                aggregateFunction: 'SUM',
                                details: null,
                            },
                            {
                                heading: 'Reach',
                                measurementName: 'REACH_COUNT',
                                aggregateFunction: 'SUM',
                                details: null,
                            },
                        ],
                        additional: null,
                    },
                ],
                profileRequests: null,
                trendRequests: null,
                children: null,
                useGlobalTimePeriod: true,
                useGlobalDataSources: false,
                globalDataSourceName: null,
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                        waitVideoEnd: false,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeZone: '',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: true,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {},
                    postVersion: 1,
                    zeroFill: false,
                    zeroKill: false,
                    cumulative: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    metricValueCountup: {
                        enabled: true,
                        duration: 30,
                    },
                    showMetricName: true,
                    metricNameSize: 15,
                    metricNameCase: 'capitalize',
                    showMetricValue: true,
                    metricValueSize: 60,
                    metricValueFormat: '1k',
                    showMetricChange: true,
                    metricPercentChangeSize: 15,
                    highlightPercentChange: false,
                    showMetricPreviousValue: false,
                    metricPreviousValueSize: 8,
                    previousValueFormat: '1k',
                    showTimeRemainder: true,
                    alignment: 'center',
                    percentChangeColor: {
                        enabled: false,
                        up: '#33CC99',
                        zero: '',
                        down: '#FF6060',
                    },
                    cell: {
                        padding: 10,
                        background: '',
                        border: {
                            enabled: true,
                            color: '',
                            size: 1,
                        },
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                        baseline: {
                            metricValueSize: 40,
                            metricNameSize: 15,
                            metricPercentChangeSize: 20,
                            gridLayout: {
                                gap: 20,
                            },
                        },
                        optionDefaults: {
                            showBackgroundCircle: true,
                        },
                    },
                    gridLayout: {
                        gap: 20,
                        columns: 3,
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                        metricValueSize: 45,
                    },
                },
            },
        ],
        useGlobalTimePeriod: true,
        useGlobalDataSources: false,
        globalDataSourceName: null,
        options: {
            player: {
                playing: false,
                duration: 15,
                waitVideoEnd: false,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            labelTimeZone: '',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: true,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            cumulative: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
            metricValueCountup: {
                enabled: true,
                duration: 30,
            },
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1569473434643,
};
export default singleMetricSnapshot;
